module.exports={
    "areg": {
        "AD": "أندورا",
        "AE": "الإمارات العربية المتحدة",
        "AF": "أفغانستان",
        "AG": "أنتيغوا وبربودا",
        "AI": "أنغيلا",
        "AL": "ألبانيا",
        "AM": "أرمينيا",
        "AN": "جزر الأنتيل الهولندية",
        "AO": "أنغولا",
        "AQ": "القطب الجنوبي",
        "AR": "الأرجنتين",
        "AS": "ساموا الأمريكية",
        "AT": "النمسا",
        "AU": "أستراليا",
        "AW": "أروبا",
        "AZ": "أذربيجان",
        "BA": "البوسنة والهرسك",
        "BB": "بربادوس",
        "BD": "بنغلاديش",
        "BE": "بلجيكا",
        "BF": "بوركينا فاسو",
        "BG": "بلغاريا",
        "BH": "البحرين",
        "BI": "بوروندي",
        "BJ": "بنين",
        "BL": "سانت بارتيليمي",
        "BM": "برمودا",
        "BN": "بروناي",
        "BO": "بوليفيا",
        "BR": "البرازيل",
        "BS": "الباهاما",
        "BT": "بوتان",
        "BW": "بوتسوانا",
        "BY": "روسيا البيضاء",
        "BZ": "بليز",
        "CA": "كندا",
        "CC": "جزر كوكوس",
        "CD": "جمهورية الكونغو الديموقراطية",
        "CF": "جمهورية افريقيا الوسطى",
        "CG": "جمهورية الكونغو",
        "CH": "سويسرا",
        "CI": "ساحل العاج",
        "CK": "جزر كوك",
        "CL": "تشيلي",
        "CM": "الكاميرون",
        "CN": "الصين",
        "CO": "كولومبيا",
        "CR": "كوستا ريكا",
        "CU": "كوبا",
        "CV": "الرأس الأخضر",
        "CW": "كوراكاو",
        "CX": "جزيرة عيد الميلاد",
        "CY": "قبرص",
        "CZ": "جمهورية التشيك",
        "DE": "ألمانيا",
        "DJ": "جيبوتي",
        "DK": "الدنمارك",
        "DM": "دومينيكا",
        "DO": "جمهورية الدومنيكان",
        "DZ": "الجزائر",
        "EC": "الإكوادور",
        "EE": "استونيا",
        "EG": "مصر",
        "EH": "الصحراء الغربية",
        "ER": "إريتريا",
        "ES": "إسبانيا",
        "ET": "أثيوبيا",
        "FI": "فنلندا",
        "FJ": "فيجي",
        "FK": "جزر فوكلاند",
        "FM": "ميكرونيزيا",
        "FO": "جزر صناعية",
        "FR": "فرنسا",
        "GA": "الغابون",
        "GB": "المملكة المتحدة",
        "GD": "غرينادا",
        "GE": "جورجيا",
        "GG": "غيرنسي",
        "GH": "غانا",
        "GI": "جبل طارق",
        "GL": "الأرض الخضراء",
        "GM": "غامبيا",
        "GN": "غينيا",
        "GQ": "غينيا الإستوائية",
        "GR": "اليونان",
        "GT": "غواتيمالا",
        "GU": "غوام",
        "GW": "غينيا بيساو",
        "GY": "غيانا",
        "HK": "هونغ كونغ",
        "HN": "هندوراس",
        "HR": "كرواتيا",
        "HT": "هايتي",
        "HU": "هنغاريا",
        "ID": "أندونيسيا",
        "IE": "أيرلندا",
        "IL": "إسرائيل",
        "IM": "جزيرة آيل أوف مان",
        "IN": "الهند",
        "IO": "إقليم المحيط البريطاني الهندي",
        "IQ": "العراق",
        "IR": "إيران",
        "IS": "أيسلندا",
        "IT": "إيطاليا",
        "JE": "جيرسي",
        "JM": "جامايكا",
        "JO": "الأردن",
        "JP": "اليابان",
        "KE": "كينيا",
        "KG": "قرغيزستان",
        "KH": "كمبوديا",
        "KI": "كيريباس",
        "KM": "جزر القمر",
        "KN": "سانت كيتس ونيفيس",
        "KP": "كوريا الشمالية",
        "KR": "كوريا الجنوبية",
        "KW": "الكويت",
        "KY": "جزر كايمان",
        "KZ": "كازاخستان",
        "LA": "لاوس",
        "LB": "لبنان",
        "LC": "سانت لوسيا",
        "LI": "ليختنشتاين",
        "LK": "سيريلانكا",
        "LR": "ليبيريا",
        "LS": "ليسوتو",
        "LT": "ليتوانيا",
        "LU": "لوكسمبورغ",
        "LV": "لاتفيا",
        "LY": "ليبيا",
        "MA": "المغرب",
        "MC": "موناكو",
        "MD": "مولدوفا",
        "ME": "الجبل الأسود",
        "MF": "سانت مارتن",
        "MG": "مدغشقر",
        "MH": "جزر مارشال",
        "MK": "مقدونيا",
        "ML": "مالي",
        "MM": "ميانمار",
        "MN": "منغوليا",
        "MO": "ماكاو",
        "MP": "جزر مريانا الشمالية",
        "MR": "موريتانيا",
        "MS": "مونتسيرات",
        "MT": "مالطا",
        "MU": "موريشيوس",
        "MV": "جزر المالديف",
        "MW": "ملاوي",
        "MX": "المكسيك",
        "MY": "ماليزيا",
        "MZ": "موزمبيق",
        "NA": "ناميبيا",
        "NC": "كاليدونيا الجديدة",
        "NE": "النيجر",
        "NG": "نيجيريا",
        "NI": "نيكاراغوا",
        "NL": "هولندا",
        "NO": "النرويج",
        "NP": "نيبال",
        "NR": "ناورو",
        "NU": "نيوي",
        "NZ": "نيوزيلاندا",
        "OM": "سلطنة عمان",
        "PA": "بناما",
        "PE": "بيرو",
        "PF": "بولينيزيا الفرنسية",
        "PG": "بابوا غينيا الجديدة",
        "PH": "الفلبين",
        "PK": "باكستان",
        "PL": "بولندا",
        "PM": "سان بيار وميكلون",
        "PN": "بيتكيرن",
        "PR": "بورتوريكو",
        "PS": "فلسطين",
        "PT": "البرتغال",
        "PW": "بالاو",
        "PY": "باراغواي",
        "QA": "قطر",
        "RE": "جمع شمل",
        "RO": "رومانيا",
        "RS": "صربيا",
        "RU": "روسيا",
        "RW": "رواندا",
        "SA": "المملكة العربية السعودية",
        "SB": "جزر سليمان",
        "SC": "سيشيل",
        "SD": "سودان",
        "SE": "السويد",
        "SG": "سنغافورة",
        "SH": "سانت هيلانة",
        "SI": "سلوفينيا",
        "SJ": "سفالبارد وجان مايان",
        "SK": "سلوفاكيا",
        "SL": "سيرا ليون",
        "SM": "سان مارينو",
        "SN": "السنغال",
        "SO": "الصومال",
        "SR": "سورينام",
        "SS": "جنوب السودان",
        "ST": "ساو تومي وبرينسيبي",
        "SV": "السلفادور",
        "SX": "سانت مارتن",
        "SY": "سوريا",
        "SZ": "سوازيلاند",
        "TC": "جزر تركس وكايكوس",
        "TD": "تشاد",
        "TG": "توغو",
        "TH": "تايلاند",
        "TJ": "طاجيكستان",
        "TK": "توكيلاو",
        "TL": "تيمور الشرقية",
        "TM": "تركمانستان",
        "TN": "تونس",
        "TO": "تونغا",
        "TR": "تركيا",
        "TT": "ترينداد وتوباغو",
        "TV": "توفالو",
        "TW": "تايوان",
        "TZ": "تنزانيا",
        "UA": "أوكرانيا",
        "UG": "أوغندا",
        "US": "الولايات المتحدة",
        "UY": "أوروغواي",
        "UZ": "أوزبكستان",
        "VA": "الفاتيكان",
        "VC": "سانت فنسنت وجزر غرينادين",
        "VE": "فنزويلا",
        "VG": "جزر فيرجن البريطانية",
        "VI": "جزر العذراء الأمريكية",
        "VN": "فيتنام",
        "VU": "فانواتو",
        "WF": "واليس وفوتونا",
        "WS": "ساموا",
        "XK": "كوسوفو",
        "YE": "اليمن",
        "YT": "مايوت",
        "ZA": "جنوب أفريقيا",
        "ZM": "زامبيا",
        "ZW": "زيمبابوي",
        "其他登录方式": "طرق تسجيل دخول أُخرى",
        "加载中": "جارٍ التحميل...",
        "参数错误": "خطأ في الكود",
        "取消": "إلغاء",
        "国家/地区": "الدولة/المنطقة",
        "打开Up直播<br/>扫一扫登录": "فتح Uplive للبث المباشر <br/> قُم بالمسح لتسجيل الدخول",
        "提示": "تنبيه",
        "搜索": "بحث",
        "正在加载": "جارٍ التحميل",
        "正在登录": "جارٍ تسجيل الدخول .",
        "正在退出...": "جارٍ الخروج",
        "登录": "تسجيل الدخول",
        "登录代表你接受Up直播《服务条款及隐私政策》": "تسجيل الدخول يُعد موافقة على《<i> بنود الخدمة </i> و<em> سياسة الخصوصية </em>》",
        "确认": "تأكيد",
        "确认退出Up直播？": "هل تريد الخروج من Uplive ؟",
        "系统错误": "خطأ فى النظام",
        "网络连接有误, 请稍后再试": "خطأ في الشبكة، يرجى المحاولة بعد قليل",
        "获取用户信息失败, 请稍后再试": "فشل فى الحصول على معلومات المستخدم، من فضلك أنتظر قليلا ثم قُم بمحاولة مرة أخرى",
        "请稍侯，正在登录中...": "برجاء الانتظار، جارٍ تسجيل الدخول ...",
        "请输入手机号码": "إدخال رقم الهاتف",
        "请输入登录密码": "يٌرجى إدخال كلمة المرور لتسجيل الدخول",
        "选择国家或地区": "قم باختيار الدولة"
    },
    "enus": {
        "AD": "Andorra",
        "AE": "United Arab Emirates",
        "AF": "Afghanistan",
        "AG": "Antigua and Barbuda",
        "AI": "Anguilla",
        "AL": "Albania",
        "AM": "Armenia",
        "AN": "Netherlands Antilles",
        "AO": "Angola",
        "AQ": "Antarctica",
        "AR": "Argentina",
        "AS": "American Samoa",
        "AT": "Austria",
        "AU": "Australia",
        "AW": "Aruba",
        "AZ": "Azerbaijan",
        "BA": "Bosnia and Herzegovina",
        "BB": "Barbados",
        "BD": "Bangladesh",
        "BE": "Belgium",
        "BF": "Burkina Faso",
        "BG": "Bulgaria",
        "BH": "Bahrain",
        "BI": "Burundi",
        "BJ": "Benin",
        "BL": "Saint Barthelemy",
        "BM": "Bermuda",
        "BN": "Brunei",
        "BO": "Bolivia",
        "BR": "Brazil",
        "BS": "Bahamas",
        "BT": "Bhutan",
        "BW": "Botswana",
        "BY": "Belarus",
        "BZ": "Belize",
        "CA": "Canada",
        "CC": "Cocos Islands",
        "CD": "Democratic Republic of the Congo",
        "CF": "Central African Republic",
        "CG": "Republic of the Congo",
        "CH": "Switzerland",
        "CI": "Ivory Coast",
        "CK": "Cook Islands",
        "CL": "Chile",
        "CM": "Cameroon",
        "CN": "China",
        "CO": "Colombia",
        "CR": "Costa Rica",
        "CU": "Cuba",
        "CV": "Cape Verde",
        "CW": "Curacao",
        "CX": "Christmas Islands",
        "CY": "Cyprus",
        "CZ": "Czech Republic",
        "DE": "Germany",
        "DJ": "Djibouti",
        "DK": "Denmark",
        "DM": "Dominica",
        "DO": "Dominican Republic",
        "DZ": "Algeria",
        "EC": "Ecuador",
        "EE": "Estonia",
        "EG": "Egypt",
        "EH": "Western Sahara",
        "ER": "Eritrea",
        "ES": "Spain",
        "ET": "Ethiopia",
        "FI": "Finland",
        "FJ": "Fiji",
        "FK": "Falkland Islands",
        "FM": "Micronesia",
        "FO": "Faroe Islands",
        "FR": "France",
        "GA": "Gabon",
        "GB": "United Kingdom",
        "GD": "Grenada",
        "GE": "Georgia",
        "GG": "Guernsey",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GL": "Greenland",
        "GM": "Gambia",
        "GN": "Guinea",
        "GQ": "Equatorial Guinea",
        "GR": "Greece",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Guinea-Bissau",
        "GY": "Guyana",
        "HK": "Hong Kong",
        "HN": "Honduras",
        "HR": "Croatia",
        "HT": "Haiti",
        "HU": "Hungary",
        "ID": "Indonesia",
        "IE": "Ireland",
        "IL": "Israel",
        "IM": "Isle of Man",
        "IN": "India",
        "IO": "British Indian Ocean Territory",
        "IQ": "Iraq",
        "IR": "Iran",
        "IS": "Iceland",
        "IT": "Italy",
        "JE": "Jersey",
        "JM": "Jamaica",
        "JO": "Jordan",
        "JP": "Japan",
        "KE": "Kenya",
        "KG": "Kyrgyzstan",
        "KH": "Cambodia",
        "KI": "Kiribati",
        "KM": "Comoros",
        "KN": "Saint Kitts and Nevis",
        "KP": "North Korea",
        "KR": "South Korea",
        "KW": "Kuwait",
        "KY": "Cayman Islands",
        "KZ": "Kazakhstan",
        "LA": "Laos",
        "LB": "Lebanon",
        "LC": "Saint Lucia",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Liberia",
        "LS": "Lesotho",
        "LT": "Lithuania",
        "LU": "Luxembourg",
        "LV": "Latvia",
        "LY": "Libya",
        "MA": "Morocco",
        "MC": "Monaco",
        "MD": "Moldova",
        "ME": "Montenegro",
        "MF": "Saint Martin",
        "MG": "Madagascar",
        "MH": "Marshall Islands",
        "MK": "Macedonia",
        "ML": "Mali",
        "MM": "Myanmar",
        "MN": "Mongolia",
        "MO": "Macau",
        "MP": "Northern Mariana Islands",
        "MR": "Mauritania",
        "MS": "Montserrat",
        "MT": "Malta",
        "MU": "Mauritius",
        "MV": "Maldives",
        "MW": "Malawi",
        "MX": "Mexico",
        "MY": "Malaysia",
        "MZ": "Mozambique",
        "NA": "Namibia",
        "NC": "New Caledonia",
        "NE": "Niger",
        "NG": "Nigeria",
        "NI": "Nicaragua",
        "NL": "Netherlands",
        "NO": "Norway",
        "NP": "Nepal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "New Zealand",
        "OM": "Oman",
        "PA": "Panama",
        "PE": "Peru",
        "PF": "French Polynesia",
        "PG": "Papua New Guinea",
        "PH": "Philippines",
        "PK": "Pakistan",
        "PL": "Poland",
        "PM": "Saint Pierre and Miquelon",
        "PN": "Pitcairn",
        "PR": "Puerto Rico",
        "PS": "Palestine",
        "PT": "Portugal",
        "PW": "Palau",
        "PY": "Paraguay",
        "QA": "Qatar",
        "RE": "Reunion",
        "RO": "Romania",
        "RS": "Serbia",
        "RU": "Russia",
        "RW": "Rwanda",
        "SA": "Saudi Arabia",
        "SB": "Solomon Islands",
        "SC": "Seychelles",
        "SD": "Sudan",
        "SE": "Sweden",
        "SG": "Singapore",
        "SH": "Saint Helena",
        "SI": "Slovenia",
        "SJ": "Svalbard and Jan Mayen",
        "SK": "Slovakia",
        "SL": "Sierra Leone",
        "SM": "San Marino",
        "SN": "Senegal",
        "SO": "Somalia",
        "SR": "Suriname",
        "SS": "South Sudan",
        "ST": "Sao Tome and Principe",
        "SV": "El Salvador",
        "SX": "Sint Maarten",
        "SY": "Syria",
        "SZ": "Swaziland",
        "TC": "Turks and Caicos Islands",
        "TD": "Chad",
        "TG": "Togo",
        "TH": "Thailand",
        "TJ": "Tajikistan",
        "TK": "Tokelau",
        "TL": "East Timor",
        "TM": "Turkmenistan",
        "TN": "Tunisia",
        "TO": "Tonga",
        "TR": "Turkey",
        "TT": "Trinidad and Tobago",
        "TV": "Tuvalu",
        "TW": "Taiwan",
        "TZ": "Tanzania",
        "UA": "Ukraine",
        "UG": "Uganda",
        "US": "United States",
        "UY": "Uruguay",
        "UZ": "Uzbekistan",
        "VA": "Vatican",
        "VC": "Saint Vincent and the Grenadines",
        "VE": "Venezuela",
        "VG": "British Virgin Islands",
        "VI": "U.S. Virgin Islands",
        "VN": "Vietnam",
        "VU": "Vanuatu",
        "WF": "Wallis and Futuna",
        "WS": "Samoa",
        "XK": "Kosovo",
        "YE": "Yemen",
        "YT": "Mayotte",
        "ZA": "South Africa",
        "ZM": "Zambia",
        "ZW": "Zimbabwe",
        "其他登录方式": "Other login method",
        "加载中": "Loading…",
        "参数错误": "error",
        "取消": "Cancel",
        "国家/地区": "Country / Region",
        "打开Up直播<br/>扫一扫登录": "Open Up live <br/> and scan to log in",
        "提示": "Reminder",
        "搜索": "Search",
        "正在加载": "Loading",
        "正在登录": "Logging in",
        "正在退出...": "Logging out...",
        "登录": "Login",
        "登录代表你接受Up直播《服务条款及隐私政策》": "Logging in means you agree UP Live's 《<i>terms of service</i> and <em> privacy policy </em>》",
        "确认": "Confirm",
        "确认退出Up直播？": "Are you sure you want to exit Uplive ?",
        "系统错误": "System error",
        "网络连接有误, 请稍后再试": "Network issue, please try again later.",
        "获取用户信息失败, 请稍后再试": "Fail to load the data, please try later",
        "请稍侯，正在登录中...": "Logging in, please wait...",
        "请输入手机号码": "Enter phone number",
        "请输入登录密码": "Enter password",
        "选择国家或地区": "Select country or region"
    },
    "jajp": {
        "AD": "アンドラ",
        "AE": "アラブ首長国連邦",
        "AF": "アフガニスタン",
        "AG": "アンチグアバーブーダ",
        "AI": "アングィラ",
        "AL": "アルバニア",
        "AM": "アルメニア",
        "AN": "オランダ領アンティル",
        "AO": "アンゴラ",
        "AQ": "南極大陸",
        "AR": "アルゼンチン",
        "AS": "アメリカ領サモア",
        "AT": "オーストリア",
        "AU": "オーストラリア",
        "AW": "アルバ",
        "AZ": "アゼルバイジャン",
        "BA": "ボスニア・ヘルツェゴビナ",
        "BB": "バルバドス",
        "BD": "バングラデシュ",
        "BE": "ベルギー",
        "BF": "ブルキナファソ",
        "BG": "ブルガリア",
        "BH": "バーレーン",
        "BI": "ブルンジ",
        "BJ": "ベニン",
        "BL": "セントバーツ",
        "BM": "バミューダ",
        "BN": "ブルネイ",
        "BO": "ボリビア",
        "BR": "ブラジル",
        "BS": "バハマ",
        "BT": "ブータン",
        "BW": "ボツワナ",
        "BY": "ベラルーシ",
        "BZ": "ベリーズ",
        "CA": "カナダ",
        "CC": "ココス諸島",
        "CD": "コンゴ民主共和国",
        "CF": "中央アフリカ共和国",
        "CG": "コンゴ共和国",
        "CH": "スイス",
        "CI": "コー​​トジボワール",
        "CK": "クック諸島",
        "CL": "チリ",
        "CM": "カメルーン",
        "CN": "中国",
        "CO": "コロンビア",
        "CR": "コスタリカ",
        "CU": "キューバ",
        "CV": "カーボベルデ",
        "CW": "キュラソー",
        "CX": "クリスマス島",
        "CY": "キプロス",
        "CZ": "チェコ共和国",
        "DE": "ドイツ",
        "DJ": "ジブチ",
        "DK": "デンマーク",
        "DM": "ドミニカ",
        "DO": "ドミニカ共和国",
        "DZ": "アルジェリア",
        "EC": "エクアドル",
        "EE": "エストニア",
        "EG": "エジプト",
        "EH": "西サハラ",
        "ER": "エリトリア",
        "ES": "スペイン",
        "ET": "エチオピア",
        "FI": "フィンランド",
        "FJ": "フィジー",
        "FK": "フォークランド諸島",
        "FM": "ミクロネシア",
        "FO": "フェロー諸島",
        "FR": "フランス",
        "GA": "ガボン",
        "GB": "イギリス",
        "GD": "グレナダ",
        "GE": "ジョージア",
        "GG": "ガーンジー島",
        "GH": "ガーナ",
        "GI": "ジブラルタル",
        "GL": "グリーンランド",
        "GM": "ガンビア",
        "GN": "ギニア",
        "GQ": "赤道ギニア",
        "GR": "ギリシャ",
        "GT": "グアテマラ",
        "GU": "グアム",
        "GW": "ギニアビサウ",
        "GY": "ガイアナ",
        "HK": "香港",
        "HN": "ホンジュラス",
        "HR": "クロアチア",
        "HT": "ハイチ",
        "HU": "ハンガリー",
        "ID": "インドネシア",
        "IE": "アイルランド",
        "IL": "イスラエル",
        "IM": "マン島",
        "IN": "インド",
        "IO": "イギリス領インド洋地域",
        "IQ": "イラク",
        "IR": "イラン",
        "IS": "アイスランド",
        "IT": "イタリア",
        "JE": "ジャージー",
        "JM": "ジャマイカ",
        "JO": "ヨルダン",
        "JP": "日本",
        "KE": "ケニア",
        "KG": "キルギスタン",
        "KH": "カンボジア",
        "KI": "キリバス",
        "KM": "コモロ",
        "KN": "セントクリストファー・ネイビス",
        "KP": "北朝鮮",
        "KR": "韓国",
        "KW": "クウェート",
        "KY": "ケイマン諸島",
        "KZ": "カザフスタン",
        "LA": "ラオス",
        "LB": "レバノン",
        "LC": "セントルシア",
        "LI": "リヒテンシュタイン",
        "LK": "スリランカ",
        "LR": "リベリア",
        "LS": "レソト",
        "LT": "リトアニア",
        "LU": "ルクセンブルク",
        "LV": "ラトビア",
        "LY": "リビア",
        "MA": "モロッコ",
        "MC": "モナコ",
        "MD": "モルドバ",
        "ME": "モンテネグロ",
        "MF": "サンマルタン島",
        "MG": "マダガスカル",
        "MH": "マーシャル諸島",
        "MK": "マケドニア",
        "ML": "マリ",
        "MM": "ミャンマー",
        "MN": "モンゴル",
        "MO": "マカオ",
        "MP": "北マリアナ諸島",
        "MR": "モーリタニア",
        "MS": "モントセラト",
        "MT": "マルタ",
        "MU": "モーリシャス",
        "MV": "モルディブ",
        "MW": "マラウイ",
        "MX": "メキシコ",
        "MY": "マレーシア",
        "MZ": "モザンビーク",
        "NA": "ナミビア",
        "NC": "ニューカレドニア",
        "NE": "ニジェール",
        "NG": "ナイジェリア",
        "NI": "ニカラグア",
        "NL": "オランダ",
        "NO": "ノルウェー",
        "NP": "ネパール",
        "NR": "ナウル",
        "NU": "ニウエ",
        "NZ": "ニュージーランド",
        "OM": "オマーン",
        "PA": "パナマ",
        "PE": "ペルー",
        "PF": "フランス領ポリネシア",
        "PG": "パプアニューギニア",
        "PH": "フィリピン",
        "PK": "パキスタン",
        "PL": "ポーランド",
        "PM": "サンピエール島・ミクロン島",
        "PN": "ピトケアン",
        "PR": "プエルトリコ",
        "PS": "パレスチナ",
        "PT": "ポルトガル",
        "PW": "パラオ",
        "PY": "パラグアイ",
        "QA": "カタール",
        "RE": "再会",
        "RO": "ルーマニア",
        "RS": "セルビア",
        "RU": "ロシア",
        "RW": "ルワンダ",
        "SA": "サウジアラビア",
        "SB": "ソロモン諸島",
        "SC": "セイシェル",
        "SD": "スーダン",
        "SE": "スウェーデン",
        "SG": "シンガポール",
        "SH": "セントヘレナ",
        "SI": "スロベニア",
        "SJ": "スバールバル諸島ヤンマイエン島",
        "SK": "スロバキア",
        "SL": "シエラレオネ",
        "SM": "サン・マリノ",
        "SN": "セネガル",
        "SO": "ソマリア",
        "SR": "スリナム",
        "SS": "南スーダン",
        "ST": "サントメプリンシペ",
        "SV": "エルサルバドル",
        "SX": "シントマールテン島",
        "SY": "シリア",
        "SZ": "スワジランド",
        "TC": "タークス・カイコス諸島",
        "TD": "チャド",
        "TG": "行く",
        "TH": "タイ",
        "TJ": "タジキスタン",
        "TK": "トケラウ諸島",
        "TL": "東ティモール",
        "TM": "トルクメニスタン",
        "TN": "チュニジア",
        "TO": "トンガ",
        "TR": "トルコ",
        "TT": "トリニダード・トバゴ",
        "TV": "ツバル",
        "TW": "台湾",
        "TZ": "タンザニア",
        "UA": "ウクライナ",
        "UG": "ウガンダ",
        "US": "アメリカ",
        "UY": "ウルグアイ",
        "UZ": "ウズベキスタン",
        "VA": "バチカン",
        "VC": "セントビンセントおよびグレナディーン諸島",
        "VE": "ベネズエラ",
        "VG": "イギリス領バージン諸島",
        "VI": "米領バージン諸島",
        "VN": "ベトナム",
        "VU": "バヌアツ",
        "WF": "ワリー・エ・フトゥーナ",
        "WS": "サモア",
        "XK": "コソボ",
        "YE": "イエメン",
        "YT": "マヨット島",
        "ZA": "南アフリカ",
        "ZM": "ザンビア",
        "ZW": "ジンバブエ",
        "其他登录方式": "他のログイン方法でログインする",
        "加载中": "ローディング…",
        "参数错误": "パラメータエラー",
        "取消": "キャンセル",
        "国家/地区": "国/地域",
        "打开Up直播<br/>扫一扫登录": "Upliveを開き<br/>\nQRコードをスキャンしよう",
        "提示": "Tips",
        "搜索": "検索",
        "正在加载": "ローディング中",
        "正在登录": "ログイン中",
        "正在退出...": "終了中......",
        "登录": "登録",
        "登录代表你接受Up直播《服务条款及隐私政策》": "Upliveにログインすることで《<i>利用規約</i>及び<em>プライバシーポリシー</em>》を承諾したことになります",
        "确认": "確認",
        "确认退出Up直播？": "Upliveを終了しますか？",
        "系统错误": "システムエラー",
        "网络连接有误, 请稍后再试": "ネット接続エラーです。後でもう一度試してください。",
        "获取用户信息失败, 请稍后再试": "ユーザデータを獲得できませんでした、再度お試しください",
        "请稍侯，正在登录中...": "ログイン中、少々お待ちください",
        "请输入手机号码": "携帯番号を入力してください",
        "请输入登录密码": "ログインパスワードを入力してください",
        "选择国家或地区": "国、地域を選択"
    },
    "kokr": {
        "AD": "안도라",
        "AE": "아랍 에미리트",
        "AF": "아프가니스탄",
        "AG": "앤티가 바부 다",
        "AI": "앵 귈라",
        "AL": "알바니아",
        "AM": "아르메니아",
        "AN": "네덜란드 령 앤 틸리 스",
        "AO": "앙골라",
        "AQ": "남극 대륙",
        "AR": "아르헨티나",
        "AS": "사모아",
        "AT": "오스트리아",
        "AU": "호주",
        "AW": "아루바",
        "AZ": "아제르바이잔",
        "BA": "보스니아 헤르체고비나",
        "BB": "바베이도스",
        "BD": "방글라데시",
        "BE": "벨기에",
        "BF": "부르 키나 파소",
        "BG": "불가리아",
        "BH": "바레인",
        "BI": "부룬디",
        "BJ": "베냉",
        "BL": "세인트 Barthelemy",
        "BM": "버뮤다",
        "BN": "브루나이",
        "BO": "볼리비아",
        "BR": "브라질",
        "BS": "바하마",
        "BT": "부탄",
        "BW": "보츠와나",
        "BY": "벨라루스",
        "BZ": "벨리즈",
        "CA": "캐나다",
        "CC": "코코스 아일랜드",
        "CD": "콩고 민주 공화국",
        "CF": "중앙 아프리카 공화국",
        "CG": "콩고 민주 공화국",
        "CH": "스위스",
        "CI": "상아 해안",
        "CK": "쿡 제도",
        "CL": "칠레",
        "CM": "카메룬",
        "CN": "중국",
        "CO": "콜롬비아",
        "CR": "코스타리카",
        "CU": "쿠바",
        "CV": "카보 베르데",
        "CW": "쿠라 카오",
        "CX": "크리스마스 제도",
        "CY": "키프로스",
        "CZ": "체코 공화국",
        "DE": "독일",
        "DJ": "지부티",
        "DK": "덴마크",
        "DM": "도미니카",
        "DO": "도미니카 공화국",
        "DZ": "알제리",
        "EC": "에콰도르",
        "EE": "에스토니아",
        "EG": "이집트",
        "EH": "서부 사하라",
        "ER": "에리트레아",
        "ES": "스페인",
        "ET": "에티오피아",
        "FI": "핀란드",
        "FJ": "피지",
        "FK": "포클랜드 제도",
        "FM": "미크로네시아",
        "FO": "파로에 군도",
        "FR": "프랑스",
        "GA": "가봉",
        "GB": "영어",
        "GD": "그레나다",
        "GE": "그루지야",
        "GG": "영국 해협에있는 작은 섬",
        "GH": "가나",
        "GI": "지브롤터",
        "GL": "그린 랜드",
        "GM": "감비아",
        "GN": "기니",
        "GQ": "적도 기니",
        "GR": "그리스",
        "GT": "과테말라",
        "GU": "괌",
        "GW": "기니 비사우",
        "GY": "가이아나",
        "HK": "홍콩",
        "HN": "온두라스",
        "HR": "크로아티아",
        "HT": "아이티",
        "HU": "헝가리",
        "ID": "인도네시아",
        "IE": "아일랜드",
        "IL": "이스라엘",
        "IM": "아일 오브 맨",
        "IN": "인도",
        "IO": "영국령 인도양 지역",
        "IQ": "이라크",
        "IR": "이란",
        "IS": "아이슬란드",
        "IT": "이탈리아",
        "JE": "뉴저지",
        "JM": "자메이카",
        "JO": "요르단",
        "JP": "일본",
        "KE": "케냐",
        "KG": "키르기스스탄",
        "KH": "캄보디아",
        "KI": "키리바시",
        "KM": "코모로",
        "KN": "세인트 키츠 네비스",
        "KP": "북한",
        "KR": "한국",
        "KW": "쿠웨이트",
        "KY": "케이맨 제도",
        "KZ": "카자흐스탄",
        "LA": "라오스",
        "LB": "레바논",
        "LC": "세인트 루시아",
        "LI": "리히텐슈타인",
        "LK": "스리랑카",
        "LR": "라이베리아",
        "LS": "레소토",
        "LT": "리투아니아",
        "LU": "룩셈부르크",
        "LV": "라트비아",
        "LY": "리비아",
        "MA": "모로코",
        "MC": "모나코",
        "MD": "몰르 더바",
        "ME": "몬테네그로",
        "MF": "산 마르틴",
        "MG": "마다가스카르",
        "MH": "마샬 군도",
        "MK": "마케도니아",
        "ML": "말리",
        "MM": "미얀마",
        "MN": "몽골리아",
        "MO": "마카오",
        "MP": "북 마리아나 제도",
        "MR": "모리타니",
        "MS": "몬 세라",
        "MT": "몰타",
        "MU": "모리셔스",
        "MV": "몰디브",
        "MW": "말라위",
        "MX": "멕시코",
        "MY": "말레이시아",
        "MZ": "모잠비크",
        "NA": "나미비아",
        "NC": "뉴 칼레도니아",
        "NE": "니제르",
        "NG": "나이지리아",
        "NI": "니카라과",
        "NL": "네덜란드",
        "NO": "노르웨이",
        "NP": "네팔",
        "NR": "나우루어",
        "NU": "니우에",
        "NZ": "뉴질랜드",
        "OM": "오만",
        "PA": "파나마",
        "PE": "페루",
        "PF": "프랑스 령 폴리네시아의",
        "PG": "파푸아 뉴기니",
        "PH": "필리핀",
        "PK": "파키스탄",
        "PL": "폴란드",
        "PM": "생 피에르 미 클롱",
        "PN": "핏 케언",
        "PR": "푸에르토 리코",
        "PS": "팔레스타인",
        "PT": "포르투갈",
        "PW": "팔라우",
        "PY": "파라과이",
        "QA": "카타르",
        "RE": "재결합",
        "RO": "루마니아",
        "RS": "세르비아",
        "RU": "러시아",
        "RW": "르완다",
        "SA": "사우디 아라비아",
        "SB": "솔로몬 제도",
        "SC": "세이셸",
        "SD": "수단",
        "SE": "스웨덴",
        "SG": "싱가포르",
        "SH": "세인트 헬레나",
        "SI": "슬로베니아",
        "SJ": "스발 바르",
        "SK": "슬로바키아",
        "SL": "시에라 리온",
        "SM": "산 마리노",
        "SN": "세네갈",
        "SO": "소말리아",
        "SR": "수리남",
        "SS": "남 수단",
        "ST": "상투 메 프린시 페",
        "SV": "엘살바도르",
        "SX": "세인트 마틴",
        "SY": "시리아",
        "SZ": "스와질란드",
        "TC": "터크 스 케이 커스 제도",
        "TD": "차드",
        "TG": "토고",
        "TH": "태국",
        "TJ": "타지키스탄",
        "TK": "토켈 라우",
        "TL": "동 티모르",
        "TM": "투르크 메니스탄",
        "TN": "튀니지",
        "TO": "통가",
        "TR": "터키",
        "TT": "트리니다드 토바고",
        "TV": "투발루",
        "TW": "대만",
        "TZ": "탄자니아",
        "UA": "우크라이나",
        "UG": "우간다",
        "US": "미국",
        "UY": "우루과이",
        "UZ": "우즈베키스탄",
        "VA": "바티칸",
        "VC": "세인트 빈센트 그레나딘",
        "VE": "베네수엘라",
        "VG": "영국령 버진 아일랜드",
        "VI": "미국 버진 아일랜드",
        "VN": "베트남",
        "VU": "바누아투",
        "WF": "월리스 푸 투나",
        "WS": "사모아",
        "XK": "코소보",
        "YE": "예멘",
        "YT": "마 요트",
        "ZA": "남아프리카 공화국",
        "ZM": "잠비아",
        "ZW": "짐바브웨",
        "其他登录方式": "다른 방식으로 로그인",
        "加载中": "로딩중...",
        "参数错误": "데이터 오류",
        "取消": "취소",
        "国家/地区": "국가 및 지역",
        "打开Up直播<br/>扫一扫登录": "Uplive 실행 후 <br/>QR코드를 스캔하여 로그인하세요.",
        "提示": "알림",
        "搜索": "검색",
        "正在加载": "로딩중",
        "正在登录": "로그인 중...",
        "正在退出...": "로그아웃 중...",
        "登录": "로그인",
        "登录代表你接受Up直播《服务条款及隐私政策》": "로그인은 Uplive의 \"<i>방송서비스</i>와 <em>개인정보취급방침</em>\"에 대한 동의를 의미합니다.",
        "确认": "확인",
        "确认退出Up直播？": "로그아웃 하시겠습니까?",
        "系统错误": "시스템 오류",
        "网络连接有误, 请稍后再试": "인터넷 연결 오류! 잠시 후 다시 시도해주세요.",
        "获取用户信息失败, 请稍后再试": "개인정보 불러오기 실패! 잠시 후 다시 시도해주세요.  ",
        "请稍侯，正在登录中...": "로그인 중... 잠시만 기다려주세요.",
        "请输入手机号码": "핸드폰 번호를 입력해주세요.",
        "请输入登录密码": "비밀번호를 입력해주세요.",
        "选择国家或地区": "국가 및 지역 선택"
    },
    "msmy": {
        "AD": "Andorra",
        "AE": "United Arab Emirates",
        "AF": "Afghanistan",
        "AG": "Antigua dan Barbuda",
        "AI": "Anguilla",
        "AL": "Albania",
        "AM": "Armenia",
        "AN": "Antillen Belanda",
        "AO": "Angola",
        "AQ": "Antartika",
        "AR": "Argentina",
        "AS": "Samoa",
        "AT": "Austria",
        "AU": "Australia",
        "AW": "Aruba",
        "AZ": "Azerbaijan",
        "BA": "Bosnia dan Herzegovina",
        "BB": "Barbados",
        "BD": "Bangladesh",
        "BE": "Belgium",
        "BF": "Burkina Faso",
        "BG": "Bulgaria",
        "BH": "Bahrain",
        "BI": "Burundi",
        "BJ": "Benin",
        "BL": "Saint Barthelemy",
        "BM": "Bermuda",
        "BN": "Brunei",
        "BO": "Bolivia",
        "BR": "Brazil",
        "BS": "Bahamas",
        "BT": "Bhutan",
        "BW": "Botswana",
        "BY": "Belarus",
        "BZ": "Belize",
        "CA": "Kanada",
        "CC": "Kepulauan Cocos",
        "CD": "Republik Demokratik Congo",
        "CF": "Republik Afrika Tengah",
        "CG": "Republik Demokratik Congo",
        "CH": "Switzerland",
        "CI": "Ivory Coast",
        "CK": "Kepulauan Cook",
        "CL": "Chile",
        "CM": "Cameroon",
        "CN": "China",
        "CO": "Colombia",
        "CR": "Costa Rica",
        "CU": "Cuba",
        "CV": "Cape Verde",
        "CW": "Curacao",
        "CX": "Pulau Krismas",
        "CY": "Cyprus",
        "CZ": "Republik Czech",
        "DE": "Jerman",
        "DJ": "Djibouti",
        "DK": "Denmark",
        "DM": "Dominica",
        "DO": "Republik Dominican",
        "DZ": "Algeria",
        "EC": "Ecuador",
        "EE": "Estonia",
        "EG": "Mesir",
        "EH": "Sahara Barat",
        "ER": "Eritrea",
        "ES": "Sepanyol",
        "ET": "Ethiopia",
        "FI": "Finland",
        "FJ": "Fiji",
        "FK": "Kepulauan Falkland",
        "FM": "Micronesia",
        "FO": "Kepulauan Faroe",
        "FR": "Perancis",
        "GA": "Gabon",
        "GB": "English",
        "GD": "Grenada",
        "GE": "Georgia",
        "GG": "Guernsey",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GL": "Greenland",
        "GM": "Gambia",
        "GN": "Guinea",
        "GQ": "Guinea Khatulistiwa",
        "GR": "Greece",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Guinea-Bissau",
        "GY": "Guyana",
        "HK": "Hong Kong",
        "HN": "Honduras",
        "HR": "Croatia",
        "HT": "Haiti",
        "HU": "Hungary",
        "ID": "Indonesia",
        "IE": "Ireland",
        "IL": "Israel",
        "IM": "Isle of Man",
        "IN": "India",
        "IO": "British Indian Ocean Territory",
        "IQ": "Iraq",
        "IR": "Iran",
        "IS": "Iceland",
        "IT": "Italy",
        "JE": "New Jersey",
        "JM": "Jamaica",
        "JO": "Jordan",
        "JP": "Jepun",
        "KE": "Kenya",
        "KG": "Kyrgyzstan",
        "KH": "Kemboja",
        "KI": "Kiribati",
        "KM": "Comoros",
        "KN": "Saint Kitts dan Nevis",
        "KP": "Korea Utara",
        "KR": "Korea",
        "KW": "Kuwait",
        "KY": "Pulau Cayman",
        "KZ": "Kazakhstan",
        "LA": "Laos",
        "LB": "Lebanon",
        "LC": "Saint Lucia",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Liberia",
        "LS": "Lesotho",
        "LT": "Lithuania",
        "LU": "Luxembourg",
        "LV": "Latvia",
        "LY": "Libya",
        "MA": "Morocco",
        "MC": "Monaco",
        "MD": "Moldova",
        "ME": "Montenegro",
        "MF": "San Martin",
        "MG": "Madagascar",
        "MH": "Kepulauan Marshall",
        "MK": "Macedonia",
        "ML": "Mali",
        "MM": "Myanmar",
        "MN": "Mongolia",
        "MO": "Macao",
        "MP": "Kepulauan Mariana Utara",
        "MR": "Mauritania",
        "MS": "Montserrat",
        "MT": "Malta",
        "MU": "Mauritius",
        "MV": "Maldives",
        "MW": "Malawi",
        "MX": "Mexico",
        "MY": "Malaysia",
        "MZ": "Mozambique",
        "NA": "Namibia",
        "NC": "New Caledonia",
        "NE": "Niger",
        "NG": "Nigeria",
        "NI": "Nicaragua",
        "NL": "Belanda",
        "NO": "Norway",
        "NP": "Nepal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "New Zealand",
        "OM": "Oman",
        "PA": "Panama",
        "PE": "Peru",
        "PF": "Polynesia Perancis",
        "PG": "Papua New Guinea",
        "PH": "filipina",
        "PK": "pakistan",
        "PL": "Poland",
        "PM": "Saint Pierre dan Miquelon",
        "PN": "Pitcairn",
        "PR": "Puerto Rico",
        "PS": "Palestin",
        "PT": "Portugal",
        "PW": "Palau",
        "PY": "Paraguay",
        "QA": "Qatar",
        "RE": "Reunion",
        "RO": "Romania",
        "RS": "Serbia",
        "RU": "Rusia",
        "RW": "Rwanda",
        "SA": "Arab Saudi",
        "SB": "Kepulauan Solomon",
        "SC": "Seychelles",
        "SD": "Sudan",
        "SE": "Sweden",
        "SG": "Singapura",
        "SH": "St. Helena",
        "SI": "Slovenia",
        "SJ": "Svalbard",
        "SK": "Slovakia",
        "SL": "Sierra Leone",
        "SM": "San Marino",
        "SN": "Senegal",
        "SO": "Somalia",
        "SR": "Surinam",
        "SS": "South Sudan",
        "ST": "Sao Tome dan Principe",
        "SV": "El Salvador",
        "SX": "Sint Maarten",
        "SY": "Syria",
        "SZ": "Swaziland",
        "TC": "Kepulauan Turks dan Caicos",
        "TD": "Chad",
        "TG": "Togo",
        "TH": "Thailand",
        "TJ": "Tajikistan",
        "TK": "Tokelau",
        "TL": "Timor Timur",
        "TM": "Turkmenistan",
        "TN": "Tunisia",
        "TO": "Tonga",
        "TR": "Turki",
        "TT": "Trinidad dan Tobago",
        "TV": "Tuvalu",
        "TW": "Taiwan",
        "TZ": "Tanzania",
        "UA": "Ukraine",
        "UG": "Uganda",
        "US": "Amerika Syarikat",
        "UY": "Uruguay",
        "UZ": "Uzbekistan",
        "VA": "Holy See",
        "VC": "Saint Vincent dan Grenadines",
        "VE": "Venezuela",
        "VG": "Kepulauan British Virgin",
        "VI": "Amerika Syarikat Kepulauan Virgin",
        "VN": "Vietnam",
        "VU": "Vanuatu",
        "WF": "Wallis dan Futuna",
        "WS": "Samoa",
        "XK": "Kosovo",
        "YE": "Yaman",
        "YT": "Mayotte",
        "ZA": "Afrika Selatan",
        "ZM": "Zambia",
        "ZW": "Zimbabwe",
        "其他登录方式": "Log masuk lain",
        "加载中": "loading",
        "参数错误": "Ralat parameter",
        "取消": "batalkan",
        "国家/地区": "Negara / rantau",
        "打开Up直播<br/>扫一扫登录": "Terbuka untuk menyapu masuk",
        "提示": "Petua",
        "搜索": "Carian",
        "正在加载": "loading",
        "正在登录": "sedang log masuk",
        "正在退出...": "sedang keluar",
        "登录": "log masuk",
        "登录代表你接受Up直播《服务条款及隐私政策》": "Log masuk bagi pihak anda menerima <i>Dasar Privasi</i> dan <em>Dasar Privasi Sehingga Langsung</em>",
        "确认": "pastikan",
        "确认退出Up直播？": "pastikan anda keluar Uplive?",
        "系统错误": "Masalah system",
        "网络连接有误, 请稍后再试": "Sambungan rangkaian adalah salah, sila cuba lagi kemudian",
        "获取用户信息失败, 请稍后再试": "gagal dapatkan mesej pengguna,sila cuba kemudian",
        "请稍侯，正在登录中...": "Sila tunggu",
        "请输入手机号码": "sila masukkan nombor telefon",
        "请输入登录密码": "sila masukkan password log masuk",
        "选择国家或地区": "Pilih negara atau wilayah"
    },
    "vivn": {
        "AD": "Andorra",
        "AE": "Các Tiểu Vương Quốc Ả Rập Thống Nhất",
        "AF": "Afghanistan",
        "AG": "Antigua và Barbuda",
        "AI": "Anguilla",
        "AL": "Albania",
        "AM": "Armenia",
        "AN": "Antille thuộc Hà Lan",
        "AO": "Angola",
        "AQ": "Nam Cực",
        "AR": "Argentina",
        "AS": "American Samoa",
        "AT": "Áo",
        "AU": "Châu Úc",
        "AW": "Aruba",
        "AZ": "Azerbaijan",
        "BA": "Bosnia và Herzegovina",
        "BB": "Barbados",
        "BD": "Bangladesh",
        "BE": "Bỉ",
        "BF": "Burkina Faso",
        "BG": "Bulgaria",
        "BH": "Bahrain",
        "BI": "Burundi",
        "BJ": "Benin",
        "BL": "Saint Barthelemy",
        "BM": "Bermuda",
        "BN": "Brunei",
        "BO": "Bolivia",
        "BR": "Brazil",
        "BS": "Bahamas",
        "BT": "Bhutan",
        "BW": "Botswana",
        "BY": "Belarus",
        "BZ": "Belize",
        "CA": "Canada",
        "CC": "Quần đảo Cocos",
        "CD": "Cộng Hòa Dân Chủ Congo",
        "CF": "Cộng Hòa Trung Phi",
        "CG": "Cộng Hòa Congo",
        "CH": "Thụy sĩ",
        "CI": "Bờ Biển Ngà",
        "CK": "Quần đảo Cook",
        "CL": "Chile",
        "CM": "Cameroon",
        "CN": "Trung Quốc",
        "CO": "Colombia",
        "CR": "Costa Rica",
        "CU": "Cuba",
        "CV": "Cape Verde",
        "CW": "Curacao",
        "CX": "Christmas Islands",
        "CY": "Cyprus",
        "CZ": "Cộng Hòa Séc",
        "DE": "Đức",
        "DJ": "Djibouti",
        "DK": "Đan Mạch",
        "DM": "Dominica",
        "DO": "Cộng Hòa Dominica",
        "DZ": "Algeria",
        "EC": "Ecuador",
        "EE": "Estonia",
        "EG": "Ai Cập",
        "EH": "Tây Sahara",
        "ER": "Eritrea",
        "ES": "Tây Ban Nha",
        "ET": "Ethiopia",
        "FI": "Phần Lan",
        "FJ": "Fiji",
        "FK": "Quần đảo Falkland",
        "FM": "Micronesia",
        "FO": "Quần đảo Faroe",
        "FR": "Pháp",
        "GA": "Gabon",
        "GB": "Vương quốc Anh",
        "GD": "Grenada",
        "GE": "Georgia",
        "GG": "Guernsey",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GL": "Greenland",
        "GM": "Gambia",
        "GN": "Guinea",
        "GQ": "Equatorial Guinea",
        "GR": "Hy Lạp",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Guinea-Bissau",
        "GY": "Guyana",
        "HK": "Hồng Kông",
        "HN": "Honduras",
        "HR": "Croatia",
        "HT": "Haiti",
        "HU": "Hungary",
        "ID": "Indonesia",
        "IE": "Ireland",
        "IL": "Israel",
        "IM": "Isle of Man",
        "IN": "Ấn Độ",
        "IO": "Lãnh thổ Anh tại Ấn Độ Dương",
        "IQ": "Iraq",
        "IR": "Iran",
        "IS": "Iceland",
        "IT": "Ý",
        "JE": "Jersey",
        "JM": "Jamaica",
        "JO": "Jordan",
        "JP": "Nhật Bản",
        "KE": "Kenya",
        "KG": "Kyrgyzstan",
        "KH": "Campuchia",
        "KI": "Kiribati",
        "KM": "Comoros",
        "KN": "Saint Kitts và Nevis",
        "KP": "Bắc Triều Tiên",
        "KR": "Hàn Quốc",
        "KW": "Kuwait",
        "KY": "Quần đảo Cayman",
        "KZ": "Kazakhstan",
        "LA": "Lào",
        "LB": "Lebanon",
        "LC": "Saint Lucia",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Liberia",
        "LS": "Lesotho",
        "LT": "Lithuania",
        "LU": "Luxembourg",
        "LV": "Latvia",
        "LY": "Libya",
        "MA": "Morocco",
        "MC": "Monaco",
        "MD": "Moldova",
        "ME": "Montenegro",
        "MF": "Saint Martin",
        "MG": "Madagascar",
        "MH": "Đảo Marshall",
        "MK": "Macedonia",
        "ML": "Mali",
        "MM": "Myanmar",
        "MN": "Mông Cổ",
        "MO": "Macau",
        "MP": "Quần đảo Bắc Mariana",
        "MR": "Mauritania",
        "MS": "Montserrat",
        "MT": "Malta",
        "MU": "Mauritius",
        "MV": "Maldives",
        "MW": "Malawi",
        "MX": "Mexico",
        "MY": "Malaysia",
        "MZ": "Mozambique",
        "NA": "Namibia",
        "NC": "New Caledonia",
        "NE": "Niger",
        "NG": "Nigeria",
        "NI": "Nicaragua",
        "NL": "Hà Lan",
        "NO": "Na Uy",
        "NP": "Nepal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "New Zealand",
        "OM": "Oman",
        "PA": "Panama",
        "PE": "Peru",
        "PF": "French Polynesia",
        "PG": "Papua New Guinea",
        "PH": "Philippines",
        "PK": "Pakistan",
        "PL": "Ba Lan",
        "PM": "Saint Pierre và Miquelon",
        "PN": "Pitcairn",
        "PR": "Puerto Rico",
        "PS": "Palestine",
        "PT": "Bồ Đào Nha",
        "PW": "Palau",
        "PY": "Paraguay",
        "QA": "Qatar",
        "RE": "Reunion",
        "RO": "Romania",
        "RS": "Serbia",
        "RU": "Nga",
        "RW": "Rwanda",
        "SA": "Ả Rập Saudi",
        "SB": "Quần đảo Solomon",
        "SC": "Seychelles",
        "SD": "Sudan",
        "SE": "Thụy Điển",
        "SG": "Singapore",
        "SH": "Saint Helena",
        "SI": "Slovenia",
        "SJ": "Svalbard và Jan Mayen",
        "SK": "Slovakia",
        "SL": "Sierra Leone",
        "SM": "San Marino",
        "SN": "Senegal",
        "SO": "Somalia",
        "SR": "Suriname",
        "SS": "Nam Sudan",
        "ST": "Sao Tome và Principe",
        "SV": "El Salvador",
        "SX": "Sint Maarten",
        "SY": "Syria",
        "SZ": "Swaziland",
        "TC": "Quần đảo Turks và Caicos",
        "TD": "Chad",
        "TG": "Togo",
        "TH": "Thái Lan",
        "TJ": "Tajikistan",
        "TK": "Tokelau",
        "TL": "Đông Timor",
        "TM": "Turkmenistan",
        "TN": "Tunisia",
        "TO": "Tonga",
        "TR": "Turkey",
        "TT": "Trinidad và Tobago",
        "TV": "Tuvalu",
        "TW": "Đài Loan",
        "TZ": "Tanzania",
        "UA": "Ukraina",
        "UG": "Uganda",
        "US": "Hoa Kỳ",
        "UY": "Uruguay",
        "UZ": "Uzbekistan",
        "VA": "Vatican",
        "VC": "Saint Vincent và Grenadines",
        "VE": "Venezuela",
        "VG": "Quần đảo British Virgin",
        "VI": "Quần đảo Virgin Mỹ",
        "VN": "Việt Nam",
        "VU": "Vanuatu",
        "WF": "Wallis và Futuna",
        "WS": "Samoa",
        "XK": "Kosovo",
        "YE": "Yemen",
        "YT": "Mayotte",
        "ZA": "Nam Phi",
        "ZM": "Zambia",
        "ZW": "Zimbabwe",
        "其他登录方式": "Đăng nhập cách khác",
        "加载中": "Đang tải....",
        "参数错误": "lỗi",
        "取消": "Huỷ",
        "国家/地区": "Quốc gia/khu vực",
        "打开Up直播<br/>扫一扫登录": "Mở Uplive<br/>Đăng nhập ngay",
        "提示": "Nhắc nhở",
        "搜索": "Tìm Kiếm",
        "正在加载": "Loading",
        "正在登录": "Đang thực hiện đăng nhập...",
        "正在退出...": "Đăng xuất...",
        "登录": "Đăng nhập",
        "登录代表你接受Up直播《服务条款及隐私政策》": "Đăng nhập có nghĩa là bạn đồng ý với các <i>điều khoản </i>và <em>chính sách</em> của Uplive.",
        "确认": "Xác nhận",
        "确认退出Up直播？": "Bạn muốn thoát khỏi Uplive ?",
        "系统错误": "Lỗi hệ thống",
        "网络连接有误, 请稍后再试": "Mạng lỗi, xin thử lại sau",
        "获取用户信息失败, 请稍后再试": "Truy cập thông tin user thất bại, thử lại sau",
        "请稍侯，正在登录中...": "Đang đăng nhập...",
        "请输入手机号码": "Nhập số điện thoại",
        "请输入登录密码": "Hãy nhập mật khẩu đăng nhập",
        "选择国家或地区": "Tỉnh/Thành phố"
    },
    "zhcn": {
        "AD": "安道尔",
        "AE": "阿拉伯联合酋长国",
        "AF": "阿富汗",
        "AG": "安提瓜和巴布达",
        "AI": "安圭拉",
        "AL": "阿尔巴尼亚",
        "AM": "亚美尼亚",
        "AN": "荷属安的列斯",
        "AO": "安哥拉",
        "AQ": "南极洲",
        "AR": "阿根廷",
        "AS": "美属萨摩亚",
        "AT": "奥地利",
        "AU": "澳大利亚",
        "AW": "阿鲁巴",
        "AZ": "阿塞拜疆",
        "BA": "波斯尼亚和黑塞哥维那",
        "BB": "巴巴多斯",
        "BD": "孟加拉国",
        "BE": "比利时",
        "BF": "布基纳法索",
        "BG": "保加利亚",
        "BH": "巴林",
        "BI": "布隆迪",
        "BJ": "贝宁",
        "BL": "圣巴泰勒米",
        "BM": "百慕大",
        "BN": "文莱",
        "BO": "玻利维亚",
        "BR": "巴西",
        "BS": "巴哈马",
        "BT": "不丹",
        "BW": "博茨瓦纳",
        "BY": "白俄罗斯",
        "BZ": "伯利兹",
        "CA": "加拿大",
        "CC": "科科斯群岛",
        "CD": "刚果民主共和国",
        "CF": "中非共和国",
        "CG": "刚果民主共和国",
        "CH": "瑞士",
        "CI": "象牙海岸",
        "CK": "库克群岛",
        "CL": "智利",
        "CM": "喀麦隆",
        "CN": "中国",
        "CO": "哥伦比亚",
        "CR": "哥斯达黎加",
        "CU": "古巴",
        "CV": "佛得角",
        "CW": "库拉索",
        "CX": "圣诞岛",
        "CY": "塞浦路斯",
        "CZ": "捷克共和国",
        "DE": "德国",
        "DJ": "吉布提",
        "DK": "丹麦",
        "DM": "多米尼加",
        "DO": "多明尼加共和国",
        "DZ": "阿尔及利亚",
        "EC": "厄瓜多尔",
        "EE": "爱沙尼亚",
        "EG": "埃及",
        "EH": "西撒哈拉",
        "ER": "厄立特里亚",
        "ES": "西班牙",
        "ET": "埃塞俄比亚",
        "FI": "芬兰",
        "FJ": "斐",
        "FK": "福克兰群岛",
        "FM": "密克罗尼西亚",
        "FO": "法罗群岛",
        "FR": "法国",
        "GA": "加蓬",
        "GB": "英国",
        "GD": "格林纳达",
        "GE": "格鲁吉亚",
        "GG": "根西岛",
        "GH": "加纳",
        "GI": "直布罗陀",
        "GL": "格陵兰",
        "GM": "冈比亚",
        "GN": "几内亚",
        "GQ": "赤道几内亚",
        "GR": "希腊",
        "GT": "危地马拉",
        "GU": "关岛",
        "GW": "几内亚比绍",
        "GY": "圭亚那",
        "HK": "香港",
        "HN": "洪都拉斯",
        "HR": "克罗地亚",
        "HT": "海地",
        "HU": "匈牙利",
        "ID": "印度尼西亚",
        "IE": "爱尔兰",
        "IL": "以色列",
        "IM": "马恩岛",
        "IN": "印度",
        "IO": "英属印度洋领地",
        "IQ": "伊拉克",
        "IR": "伊朗",
        "IS": "冰岛",
        "IT": "意大利",
        "JE": "新泽西",
        "JM": "牙买加",
        "JO": "约旦",
        "JP": "日本",
        "KE": "肯尼亚",
        "KG": "吉尔吉斯斯坦",
        "KH": "柬埔寨",
        "KI": "基里巴斯",
        "KM": "科摩罗",
        "KN": "圣基茨和尼维斯",
        "KP": "北朝鲜",
        "KR": "韩国",
        "KW": "科威特",
        "KY": "开曼群岛",
        "KZ": "哈萨克斯坦",
        "LA": "老挝",
        "LB": "黎巴嫩",
        "LC": "圣卢西亚",
        "LI": "列支敦士登",
        "LK": "斯里兰卡",
        "LR": "利比里亚",
        "LS": "莱索托",
        "LT": "立陶宛",
        "LU": "卢森堡",
        "LV": "拉脱维亚",
        "LY": "利比亚",
        "MA": "摩洛哥",
        "MC": "摩纳哥",
        "MD": "摩尔多瓦",
        "ME": "黑山",
        "MF": "圣马丁",
        "MG": "马达加斯加",
        "MH": "马绍尔群岛",
        "MK": "马其顿",
        "ML": "马里",
        "MM": "缅甸",
        "MN": "蒙古",
        "MO": "澳门",
        "MP": "北马里亚纳群岛",
        "MR": "毛里塔尼亚",
        "MS": "蒙特塞拉特",
        "MT": "马耳他",
        "MU": "毛里求斯",
        "MV": "马尔代夫",
        "MW": "马拉维",
        "MX": "墨西哥",
        "MY": "马来西亚",
        "MZ": "莫桑比克",
        "NA": "纳米比亚",
        "NC": "新喀里多尼亚",
        "NE": "尼日尔",
        "NG": "尼日利亚",
        "NI": "尼加拉瓜",
        "NL": "荷兰",
        "NO": "挪威",
        "NP": "尼泊尔",
        "NR": "瑙鲁",
        "NU": "纽埃",
        "NZ": "新西兰",
        "OM": "阿曼",
        "PA": "巴拿马",
        "PE": "秘鲁",
        "PF": "法属波利尼西亚",
        "PG": "巴布亚新几内亚",
        "PH": "菲律宾",
        "PK": "巴基斯坦",
        "PL": "波兰",
        "PM": "圣皮埃尔和密克隆",
        "PN": "皮特凯恩",
        "PR": "波多黎各",
        "PS": "巴勒斯坦",
        "PT": "葡萄牙",
        "PW": "帕劳",
        "PY": "巴拉圭",
        "QA": "卡塔尔",
        "RE": "团圆",
        "RO": "罗马尼亚",
        "RS": "塞尔维亚",
        "RU": "俄国",
        "RW": "卢旺达",
        "SA": "沙特阿拉伯",
        "SB": "所罗门群岛",
        "SC": "塞舌尔",
        "SD": "苏丹",
        "SE": "瑞典",
        "SG": "新加坡",
        "SH": "圣赫勒拿",
        "SI": "斯洛文尼亚",
        "SJ": "斯瓦尔巴特",
        "SK": "斯洛伐克",
        "SL": "塞拉利昂",
        "SM": "圣马力诺",
        "SN": "塞内加尔",
        "SO": "索马里",
        "SR": "苏里南",
        "SS": "南苏丹",
        "ST": "圣多美和普林西比",
        "SV": "萨尔瓦多",
        "SX": "圣马丁岛",
        "SY": "叙利亚",
        "SZ": "斯威士兰",
        "TC": "特克斯和凯科斯群岛",
        "TD": "乍得",
        "TG": "多哥",
        "TH": "泰国",
        "TJ": "塔吉克斯坦",
        "TK": "托克劳",
        "TL": "东帝汶",
        "TM": "土库曼斯坦",
        "TN": "突尼斯",
        "TO": "汤加",
        "TR": "土耳其",
        "TT": "特立尼达和多巴哥",
        "TV": "图瓦卢",
        "TW": "台湾",
        "TZ": "坦桑尼亚",
        "UA": "乌克兰",
        "UG": "乌干达",
        "US": "美国",
        "UY": "乌拉圭",
        "UZ": "乌兹别克斯坦",
        "VA": "教廷",
        "VC": "圣文森特和格林纳丁斯",
        "VE": "委内瑞拉",
        "VG": "英属维尔京群岛",
        "VI": "美属维尔京群岛",
        "VN": "越南",
        "VU": "瓦努阿图",
        "WF": "瓦利斯和富图纳群岛",
        "WS": "萨摩亚",
        "XK": "科索沃",
        "YE": "也门",
        "YT": "马约特",
        "ZA": "南非",
        "ZM": "赞比亚",
        "ZW": "津巴布韦",
        "其他登录方式": "其他登录方式",
        "加载中": "加载中…",
        "参数错误": "参数错误",
        "取消": "取消",
        "国家/地区": "国家/地区",
        "打开Up直播<br/>扫一扫登录": "打开Uplive<br/>扫一扫登录",
        "提示": "提示",
        "搜索": "搜索",
        "正在加载": "正在加载",
        "正在登录": "正在登录",
        "正在退出...": "正在退出...",
        "登录": "登录",
        "登录代表你接受Up直播《服务条款及隐私政策》": "登录代表你接受Uplive《<i>服务条款</i>及<em>隐私政策</em>》",
        "确认": "确认",
        "确认退出Up直播？": "确认退出Uplive？",
        "系统错误": "系统错误",
        "网络连接有误, 请稍后再试": "网络连接有误, 请稍后再试",
        "获取用户信息失败, 请稍后再试": "获取用户信息失败, 请稍后再试",
        "请稍侯，正在登录中...": "请稍侯，正在登录中...",
        "请输入手机号码": "请输入手机号码",
        "请输入登录密码": "请输入登录密码",
        "选择国家或地区": "选择国家或地区"
    },
    "zhhk": {
        "AD": "安道​​爾",
        "AE": "阿拉伯聯合酋長國",
        "AF": "阿富汗",
        "AG": "安提瓜和巴布達",
        "AI": "安圭拉",
        "AL": "阿爾巴尼亞",
        "AM": "亞美尼亞",
        "AN": "荷屬安的列斯",
        "AO": "安哥拉",
        "AQ": "南極洲",
        "AR": "阿根廷",
        "AS": "美屬薩摩亞",
        "AT": "奧地利",
        "AU": "澳大利亞",
        "AW": "阿魯巴",
        "AZ": "阿塞拜疆",
        "BA": "波斯尼亞和黑塞哥維那",
        "BB": "巴巴多斯",
        "BD": "孟加拉國",
        "BE": "比利時",
        "BF": "布基納法索",
        "BG": "保加利亞",
        "BH": "巴林",
        "BI": "布隆迪",
        "BJ": "貝寧",
        "BL": "聖巴泰勒米",
        "BM": "百慕大",
        "BN": "文萊",
        "BO": "玻利維亞",
        "BR": "巴西",
        "BS": "巴哈馬",
        "BT": "不丹",
        "BW": "博茨瓦納",
        "BY": "白俄羅斯",
        "BZ": "伯利茲",
        "CA": "加拿大",
        "CC": "科科斯群島",
        "CD": "剛果民主共和國",
        "CF": "中非共和國",
        "CG": "剛果民主共和國",
        "CH": "瑞士",
        "CI": "象牙海岸",
        "CK": "庫克群島",
        "CL": "智利",
        "CM": "喀麥隆",
        "CN": "中國",
        "CO": "哥倫比亞",
        "CR": "哥斯達黎加",
        "CU": "古巴",
        "CV": "佛得角",
        "CW": "庫拉索",
        "CX": "聖誕島",
        "CY": "塞浦路斯",
        "CZ": "捷克共和國",
        "DE": "德國",
        "DJ": "吉布提",
        "DK": "丹麥",
        "DM": "多米尼加",
        "DO": "多明尼加共和國",
        "DZ": "阿爾及利亞",
        "EC": "厄瓜多爾",
        "EE": "愛沙尼亞",
        "EG": "埃及",
        "EH": "西撒哈拉",
        "ER": "厄立特里亞",
        "ES": "西班牙",
        "ET": "埃塞俄比亞",
        "FI": "芬蘭",
        "FJ": "斐",
        "FK": "福克蘭群島",
        "FM": "密克羅尼西亞",
        "FO": "法羅群島",
        "FR": "法國",
        "GA": "加蓬",
        "GB": "英國",
        "GD": "格林納達",
        "GE": "格魯吉亞",
        "GG": "根西島",
        "GH": "加納",
        "GI": "直布羅陀",
        "GL": "格陵蘭",
        "GM": "岡比亞",
        "GN": "幾內亞",
        "GQ": "赤道幾內亞",
        "GR": "希臘",
        "GT": "危地馬拉",
        "GU": "關島",
        "GW": "幾內亞比紹",
        "GY": "圭亞那",
        "HK": "香港",
        "HN": "洪都拉斯",
        "HR": "克羅地亞",
        "HT": "海地",
        "HU": "匈牙利",
        "ID": "印度尼西亞",
        "IE": "愛爾蘭",
        "IL": "以色列",
        "IM": "馬恩島",
        "IN": "印度",
        "IO": "英屬印度洋領地",
        "IQ": "伊拉克",
        "IR": "伊朗",
        "IS": "冰島",
        "IT": "意大利",
        "JE": "新澤西",
        "JM": "牙買加",
        "JO": "約旦",
        "JP": "日本",
        "KE": "肯尼亞",
        "KG": "吉爾吉斯斯坦",
        "KH": "柬埔寨",
        "KI": "基里巴斯",
        "KM": "科摩羅",
        "KN": "聖基茨和尼維斯",
        "KP": "北朝鮮",
        "KR": "韓國",
        "KW": "科威特",
        "KY": "開曼群島",
        "KZ": "哈薩克斯坦",
        "LA": "老撾",
        "LB": "黎巴嫩",
        "LC": "聖盧西亞",
        "LI": "列支敦士登",
        "LK": "斯里蘭卡",
        "LR": "利比里亞",
        "LS": "萊索托",
        "LT": "立陶宛",
        "LU": "盧森堡",
        "LV": "拉脫維亞",
        "LY": "利比亞",
        "MA": "摩洛哥",
        "MC": "摩納哥",
        "MD": "摩爾多瓦",
        "ME": "黑山",
        "MF": "聖馬丁",
        "MG": "馬達加斯加",
        "MH": "馬紹爾群島",
        "MK": "馬其頓",
        "ML": "馬里",
        "MM": "緬甸",
        "MN": "蒙古",
        "MO": "澳門",
        "MP": "北馬里亞納群島",
        "MR": "毛里塔尼亞",
        "MS": "蒙特塞拉特",
        "MT": "馬耳他",
        "MU": "毛里求斯",
        "MV": "馬爾代夫",
        "MW": "馬拉維",
        "MX": "墨西哥",
        "MY": "馬來西亞",
        "MZ": "莫桑比克",
        "NA": "納米比亞",
        "NC": "新喀裡多尼亞",
        "NE": "尼日爾",
        "NG": "尼日利亞",
        "NI": "尼加拉瓜",
        "NL": "荷蘭",
        "NO": "挪威",
        "NP": "尼泊爾",
        "NR": "瑙魯",
        "NU": "紐埃",
        "NZ": "新西蘭",
        "OM": "阿曼",
        "PA": "巴拿馬",
        "PE": "秘魯",
        "PF": "法屬波利尼西亞",
        "PG": "巴布亞新幾內亞",
        "PH": "菲律賓",
        "PK": "巴基斯坦",
        "PL": "波蘭",
        "PM": "聖皮埃爾和密克隆",
        "PN": "皮特凱恩",
        "PR": "波多黎各",
        "PS": "巴勒斯坦",
        "PT": "葡萄牙",
        "PW": "帕勞",
        "PY": "巴拉圭",
        "QA": "卡塔爾",
        "RE": "團圓",
        "RO": "羅馬尼亞",
        "RS": "塞爾維亞",
        "RU": "俄國",
        "RW": "盧旺達",
        "SA": "沙特阿拉伯",
        "SB": "所羅門群島",
        "SC": "塞舌爾",
        "SD": "蘇丹",
        "SE": "瑞典",
        "SG": "新加坡",
        "SH": "聖赫勒拿",
        "SI": "斯洛文尼亞",
        "SJ": "斯瓦爾巴特",
        "SK": "斯洛伐克",
        "SL": "塞拉利昂",
        "SM": "聖馬力諾",
        "SN": "塞內加爾",
        "SO": "索馬里",
        "SR": "蘇里南",
        "SS": "南蘇丹",
        "ST": "聖多美和普林西比",
        "SV": "薩爾瓦多",
        "SX": "聖馬丁島",
        "SY": "敘利亞",
        "SZ": "斯威士蘭",
        "TC": "特克斯和凱科斯群島",
        "TD": "乍得",
        "TG": "多哥",
        "TH": "泰國",
        "TJ": "塔吉克斯坦",
        "TK": "托克勞",
        "TL": "東帝汶",
        "TM": "土庫曼斯坦",
        "TN": "突尼斯",
        "TO": "湯加",
        "TR": "土耳其",
        "TT": "特立尼達和多巴哥",
        "TV": "圖瓦盧",
        "TW": "台灣",
        "TZ": "坦桑尼亞",
        "UA": "烏克蘭",
        "UG": "烏干達",
        "US": "美國",
        "UY": "烏拉圭",
        "UZ": "烏茲別克斯坦",
        "VA": "教廷",
        "VC": "聖文森特和格林納丁斯",
        "VE": "委內瑞拉",
        "VG": "英屬維爾京群島",
        "VI": "美屬維爾京群島",
        "VN": "越南",
        "VU": "瓦努阿圖",
        "WF": "瓦利斯和富圖納群島",
        "WS": "薩摩亞",
        "XK": "科索沃",
        "YE": "也門",
        "YT": "馬約特",
        "ZA": "南非",
        "ZM": "贊比亞",
        "ZW": "津巴布韋",
        "其他登录方式": "其他登錄方式",
        "加载中": "載入中...",
        "参数错误": "參數錯誤",
        "取消": "取消",
        "国家/地区": "國家/地區",
        "打开Up直播<br/>扫一扫登录": "打開Up直播<br/>掃QR Code登錄",
        "提示": "提示",
        "搜索": "搜尋",
        "正在加载": "正在載入",
        "正在登录": "登入中",
        "正在退出...": "退出中...",
        "登录": "登入",
        "登录代表你接受Up直播《服务条款及隐私政策》": "登入即代表您接受Up直播《<i>服務條款</i>及<em>隱私政策</em>》",
        "确认": "確定",
        "确认退出Up直播？": "確定退出 Uplive？",
        "系统错误": "系統錯誤",
        "网络连接有误, 请稍后再试": "網絡環境異常，請稍候再試",
        "获取用户信息失败, 请稍后再试": "獲取用戶訊息失敗，請稍後再試",
        "请稍侯，正在登录中...": "請稍候，正在登入中...",
        "请输入手机号码": "使用手機號碼登錄",
        "请输入登录密码": "請輸入登入密碼",
        "选择国家或地区": "選擇國家或地區"
    },
    "zhtw": {
        "AD": "安道​​爾",
        "AE": "阿拉伯聯合酋長國",
        "AF": "阿富汗",
        "AG": "安提瓜和巴布達",
        "AI": "安圭拉",
        "AL": "阿爾巴尼亞",
        "AM": "亞美尼亞",
        "AN": "荷屬安的列斯",
        "AO": "安哥拉",
        "AQ": "南極洲",
        "AR": "阿根廷",
        "AS": "美屬薩摩亞",
        "AT": "奧地利",
        "AU": "澳大利亞",
        "AW": "阿魯巴",
        "AZ": "阿塞拜疆",
        "BA": "波斯尼亞和黑塞哥維那",
        "BB": "巴巴多斯",
        "BD": "孟加拉國",
        "BE": "比利時",
        "BF": "布基納法索",
        "BG": "保加利亞",
        "BH": "巴林",
        "BI": "布隆迪",
        "BJ": "貝寧",
        "BL": "聖巴泰勒米",
        "BM": "百慕大",
        "BN": "文萊",
        "BO": "玻利維亞",
        "BR": "巴西",
        "BS": "巴哈馬",
        "BT": "不丹",
        "BW": "博茨瓦納",
        "BY": "白俄羅斯",
        "BZ": "伯利茲",
        "CA": "加拿大",
        "CC": "科科斯群島",
        "CD": "剛果民主共和國",
        "CF": "中非共和國",
        "CG": "剛果民主共和國",
        "CH": "瑞士",
        "CI": "象牙海岸",
        "CK": "庫克群島",
        "CL": "智利",
        "CM": "喀麥隆",
        "CN": "中國",
        "CO": "哥倫比亞",
        "CR": "哥斯達黎加",
        "CU": "古巴",
        "CV": "佛得角",
        "CW": "庫拉索",
        "CX": "聖誕島",
        "CY": "塞浦路斯",
        "CZ": "捷克共和國",
        "DE": "德國",
        "DJ": "吉布提",
        "DK": "丹麥",
        "DM": "多米尼加",
        "DO": "多明尼加共和國",
        "DZ": "阿爾及利亞",
        "EC": "厄瓜多爾",
        "EE": "愛沙尼亞",
        "EG": "埃及",
        "EH": "西撒哈拉",
        "ER": "厄立特里亞",
        "ES": "西班牙",
        "ET": "埃塞俄比亞",
        "FI": "芬蘭",
        "FJ": "斐",
        "FK": "福克蘭群島",
        "FM": "密克羅尼西亞",
        "FO": "法羅群島",
        "FR": "法國",
        "GA": "加蓬",
        "GB": "英國",
        "GD": "格林納達",
        "GE": "格魯吉亞",
        "GG": "根西島",
        "GH": "加納",
        "GI": "直布羅陀",
        "GL": "格陵蘭",
        "GM": "岡比亞",
        "GN": "幾內亞",
        "GQ": "赤道幾內亞",
        "GR": "希臘",
        "GT": "危地馬拉",
        "GU": "關島",
        "GW": "幾內亞比紹",
        "GY": "圭亞那",
        "HK": "香港",
        "HN": "洪都拉斯",
        "HR": "克羅地亞",
        "HT": "海地",
        "HU": "匈牙利",
        "ID": "印度尼西亞",
        "IE": "愛爾蘭",
        "IL": "以色列",
        "IM": "馬恩島",
        "IN": "印度",
        "IO": "英屬印度洋領地",
        "IQ": "伊拉克",
        "IR": "伊朗",
        "IS": "冰島",
        "IT": "意大利",
        "JE": "新澤西",
        "JM": "牙買加",
        "JO": "約旦",
        "JP": "日本",
        "KE": "肯尼亞",
        "KG": "吉爾吉斯斯坦",
        "KH": "柬埔寨",
        "KI": "基里巴斯",
        "KM": "科摩羅",
        "KN": "聖基茨和尼維斯",
        "KP": "北朝鮮",
        "KR": "韓國",
        "KW": "科威特",
        "KY": "開曼群島",
        "KZ": "哈薩克斯坦",
        "LA": "老撾",
        "LB": "黎巴嫩",
        "LC": "聖盧西亞",
        "LI": "列支敦士登",
        "LK": "斯里蘭卡",
        "LR": "利比里亞",
        "LS": "萊索托",
        "LT": "立陶宛",
        "LU": "盧森堡",
        "LV": "拉脫維亞",
        "LY": "利比亞",
        "MA": "摩洛哥",
        "MC": "摩納哥",
        "MD": "摩爾多瓦",
        "ME": "黑山",
        "MF": "聖馬丁",
        "MG": "馬達加斯加",
        "MH": "馬紹爾群島",
        "MK": "馬其頓",
        "ML": "馬里",
        "MM": "緬甸",
        "MN": "蒙古",
        "MO": "澳門",
        "MP": "北馬里亞納群島",
        "MR": "毛里塔尼亞",
        "MS": "蒙特塞拉特",
        "MT": "馬耳他",
        "MU": "毛里求斯",
        "MV": "馬爾代夫",
        "MW": "馬拉維",
        "MX": "墨西哥",
        "MY": "馬來西亞",
        "MZ": "莫桑比克",
        "NA": "納米比亞",
        "NC": "新喀裡多尼亞",
        "NE": "尼日爾",
        "NG": "尼日利亞",
        "NI": "尼加拉瓜",
        "NL": "荷蘭",
        "NO": "挪威",
        "NP": "尼泊爾",
        "NR": "瑙魯",
        "NU": "紐埃",
        "NZ": "新西蘭",
        "OM": "阿曼",
        "PA": "巴拿馬",
        "PE": "秘魯",
        "PF": "法屬波利尼西亞",
        "PG": "巴布亞新幾內亞",
        "PH": "菲律賓",
        "PK": "巴基斯坦",
        "PL": "波蘭",
        "PM": "聖皮埃爾和密克隆",
        "PN": "皮特凱恩",
        "PR": "波多黎各",
        "PS": "巴勒斯坦",
        "PT": "葡萄牙",
        "PW": "帕勞",
        "PY": "巴拉圭",
        "QA": "卡塔爾",
        "RE": "團圓",
        "RO": "羅馬尼亞",
        "RS": "塞爾維亞",
        "RU": "俄國",
        "RW": "盧旺達",
        "SA": "沙特阿拉伯",
        "SB": "所羅門群島",
        "SC": "塞舌爾",
        "SD": "蘇丹",
        "SE": "瑞典",
        "SG": "新加坡",
        "SH": "聖赫勒拿",
        "SI": "斯洛文尼亞",
        "SJ": "斯瓦爾巴特",
        "SK": "斯洛伐克",
        "SL": "塞拉利昂",
        "SM": "聖馬力諾",
        "SN": "塞內加爾",
        "SO": "索馬里",
        "SR": "蘇里南",
        "SS": "南蘇丹",
        "ST": "聖多美和普林西比",
        "SV": "薩爾瓦多",
        "SX": "聖馬丁島",
        "SY": "敘利亞",
        "SZ": "斯威士蘭",
        "TC": "特克斯和凱科斯群島",
        "TD": "乍得",
        "TG": "多哥",
        "TH": "泰國",
        "TJ": "塔吉克斯坦",
        "TK": "托克勞",
        "TL": "東帝汶",
        "TM": "土庫曼斯坦",
        "TN": "突尼斯",
        "TO": "湯加",
        "TR": "土耳其",
        "TT": "特立尼達和多巴哥",
        "TV": "圖瓦盧",
        "TW": "台灣",
        "TZ": "坦桑尼亞",
        "UA": "烏克蘭",
        "UG": "烏干達",
        "US": "美國",
        "UY": "烏拉圭",
        "UZ": "烏茲別克斯坦",
        "VA": "教廷",
        "VC": "聖文森特和格林納丁斯",
        "VE": "委內瑞拉",
        "VG": "英屬維爾京群島",
        "VI": "美屬維爾京群島",
        "VN": "越南",
        "VU": "瓦努阿圖",
        "WF": "瓦利斯和富圖納群島",
        "WS": "薩摩亞",
        "XK": "科索沃",
        "YE": "也門",
        "YT": "馬約特",
        "ZA": "南非",
        "ZM": "贊比亞",
        "ZW": "津巴布韋",
        "其他登录方式": "其他登入方式",
        "加载中": "載入中...",
        "参数错误": "參數錯誤",
        "取消": "取消",
        "国家/地区": "國家/地區",
        "打开Up直播<br/>扫一扫登录": "打開Up直播<br/>掃一掃登入",
        "提示": "提示",
        "搜索": "搜尋",
        "正在加载": "正在載入",
        "正在登录": "登入中",
        "正在退出...": "退出中...",
        "登录": "登入",
        "登录代表你接受Up直播《服务条款及隐私政策》": "登入即代表您接受Up直播《<i>服務條款</i>及<em>隱私政策</em>》",
        "确认": "確定",
        "确认退出Up直播？": "掰，咱們回頭見！",
        "系统错误": "系統錯誤",
        "网络连接有误, 请稍后再试": "網絡環境異常，請稍候再試",
        "获取用户信息失败, 请稍后再试": "獲取用戶訊息失敗，請稍後再試",
        "请稍侯，正在登录中...": "請稍候，正在登入中...",
        "请输入手机号码": "使用手機號碼登錄",
        "请输入登录密码": "請輸入登入密碼",
        "选择国家或地区": "選擇國家或地區"
    }
}


// WEBPACK FOOTER //
// ./js/component/openjs/lang/pack.js